(() => {
  if (window.MagazineArchiveControls) {
    window.MagazineArchiveControls.init(document);
    return;
  }

  const roots = new WeakSet();
  const controls = new WeakMap();

  function closeOthers(current) {
    document.querySelectorAll('.magazine-archive [data-archive-control][open]').forEach((details) => {
      if (details !== current) details.open = false;
    });
  }

  function enhance(select) {
    if (controls.has(select)) return controls.get(select);

    const wrapper = select.parentElement;
    const label = wrapper.querySelector('label');
    const icons = wrapper.querySelector('template[data-archive-control-icons]');
    const caret = icons?.content.querySelector('[data-archive-control-caret]');
    const check = icons?.content.querySelector('[data-archive-control-check]');
    if (!label || !caret || !check) return null;

    const isCategory = select.hasAttribute('data-archive-category');
    const labelText = label.textContent.trim();
    const topicLabel = wrapper.dataset.topicLabel || labelText;
    const details = document.createElement('details');
    details.className = 'magazine-archive__control';
    details.setAttribute('data-archive-control', '');

    const summary = document.createElement('summary');
    summary.className = 'magazine-archive__control-trigger';
    summary.setAttribute('aria-expanded', 'false');

    const prefix = document.createElement('span');
    prefix.className = 'magazine-archive__control-prefix';
    prefix.textContent = /[:：]$/.test(labelText) ? labelText : `${labelText}:`;
    if (!isCategory) summary.append(prefix);

    const value = document.createElement('span');
    value.className = 'magazine-archive__control-value';
    summary.append(value, caret.cloneNode(true));

    const list = document.createElement('ul');
    list.id = `${select.id}-Options`;
    list.className = 'magazine-archive__control-options';
    list.setAttribute('aria-label', isCategory ? topicLabel : labelText);
    summary.setAttribute('aria-controls', list.id);
    details.append(summary, list);

    let optionSignature = '';

    function sync() {
      const options = Array.from(select.options);
      const signature = JSON.stringify(options.map((option) => [option.value, option.label, option.disabled]));
      if (signature !== optionSignature) {
        const focusedValue = list.contains(document.activeElement)
          ? document.activeElement.dataset.archiveControlValue
          : null;
        const fragment = document.createDocumentFragment();
        options.forEach((option) => {
          const item = document.createElement('li');
          const button = document.createElement('button');
          const text = document.createElement('span');
          button.type = 'button';
          button.className = 'magazine-archive__control-option';
          button.dataset.archiveControlValue = option.value;
          button.disabled = option.disabled;
          text.textContent = option.label;
          button.append(text, check.cloneNode(true));
          item.append(button);
          fragment.append(item);
        });
        list.replaceChildren(fragment);
        optionSignature = signature;
        if (focusedValue !== null) {
          const replacement = Array.from(list.querySelectorAll('button')).find(
            (button) => button.dataset.archiveControlValue === focusedValue,
          );
          (replacement || summary).focus();
        }
      }

      const selectedLabel = select.selectedOptions[0]?.label || '';
      value.textContent = isCategory ? topicLabel : selectedLabel;
      summary.setAttribute(
        'aria-label',
        isCategory ? `${topicLabel}: ${selectedLabel}` : `${prefix.textContent} ${selectedLabel}`,
      );
      list.querySelectorAll('button').forEach((button) => {
        const selected = button.dataset.archiveControlValue === select.value;
        button.setAttribute('aria-pressed', String(selected));
        button.querySelector('[data-archive-control-check]').hidden = !selected;
      });
    }

    list.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-archive-control-value]');
      if (!button || button.disabled) return;
      select.value = button.dataset.archiveControlValue;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      details.open = false;
      summary.focus();
    });

    details.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(details.open));
      if (details.open) closeOthers(details);
    });

    details.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        // Wait for Tab's focus move; iOS can blur to <main> during an option tap.
        setTimeout(() => {
          if (!details.contains(document.activeElement)) details.open = false;
        }, 0);
        return;
      }

      if (event.key === 'Escape' && details.open) {
        event.preventDefault();
        event.stopPropagation();
        details.open = false;
        summary.focus();
        return;
      }

      const buttons = Array.from(list.querySelectorAll('button:not(:disabled)'));
      if (!buttons.length) return;
      const fromSummary = event.target === summary;
      const index = buttons.indexOf(document.activeElement);
      let nextIndex;
      if (event.key === 'ArrowDown') {
        nextIndex = fromSummary ? 0 : (index + 1) % buttons.length;
      } else if (event.key === 'ArrowUp') {
        nextIndex = fromSummary ? buttons.length - 1 : (index - 1 + buttons.length) % buttons.length;
      } else if (!fromSummary && event.key === 'Home') {
        nextIndex = 0;
      } else if (!fromSummary && event.key === 'End') {
        nextIndex = buttons.length - 1;
      } else {
        return;
      }
      event.preventDefault();
      details.open = true;
      buttons[nextIndex].focus();
    });

    select.addEventListener('change', sync);
    sync();
    wrapper.append(details);
    select.hidden = true;
    label.hidden = true;
    controls.set(select, sync);
    return sync;
  }

  function syncRoot(root) {
    root.querySelectorAll('[data-archive-category], [data-archive-sort]').forEach((select) => {
      enhance(select)?.();
    });
  }

  function init(scope) {
    const archives = Array.from(scope.querySelectorAll('[data-magazine-archive]'));
    if (scope.matches?.('[data-magazine-archive]')) archives.unshift(scope);
    archives.forEach((root) => {
      if (!roots.has(root)) {
        root.addEventListener('magazine:archive:render', () => syncRoot(root));
        roots.add(root);
      }
      syncRoot(root);
    });
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.magazine-archive [data-archive-control][open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.MagazineArchiveControls = { init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), {
      once: true,
    });
  } else {
    init(document);
  }
})();
